module.exports = __webpack_public_path__ + "img/menu.5aa3feb5.png";